import { render } from "./light_page.vue?vue&type=template&id=4224990d&scoped=true"
import script from "./light_page.vue?vue&type=script&lang=js"
export * from "./light_page.vue?vue&type=script&lang=js"

import "./light_page.vue?vue&type=style&index=0&id=4224990d&lang=scss&scoped=true"
import "./light_page.vue?vue&type=style&index=1&id=4224990d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4224990d"]])

export default __exports__